// Refactored ApiService - uses service modules for better organization
import safeJsonParse from '../utils/jsonSafe';
import ErrorHandler from '../utils/errorHandler';
import Logger from '../utils/logger';
import { BaseApiService } from './baseApiService';
import { AuthService } from './authService';

// Determine API host: use environment variable, or same hostname as frontend, or default to localhost
const getApiHost = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  const API_PORT = process.env.REACT_APP_API_PORT || '8006';
  
  if (typeof window !== 'undefined') {
    // Electron desktop app loads from file:// — use hosted backend (nginx proxies /api/)
    if (window.location?.protocol === 'file:' || window.electronAPI !== undefined) {
      return 'https://chipdesigner.ai';
    }
    
    if (window.location?.hostname) {
      const hostname = window.location.hostname;
      const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
      
      // For chipdesigner domains, use same origin (nginx proxies /api/ to backend)
      if (hostname === 'chipdesigner.ai' || hostname.endsWith('.chipdesigner.ai')) {
        return `${protocol}://${hostname}`;
      }
      
      return `${protocol}://${hostname}:${API_PORT}`;
    }
  }
  
  return `http://localhost:${API_PORT}`;
};

const API_BASE_URL = getApiHost();

class ApiService extends BaseApiService {
  constructor() {
    super();
    
    // Compose services
    this.auth = new AuthService(this);
    
    // Delegate auth methods to AuthService
    this.processSession = this.auth.processSession.bind(this.auth);
    this.googleAuth = this.auth.googleAuth.bind(this.auth);
    this.emailLogin = this.auth.emailLogin.bind(this.auth);
    this.emailRegister = this.auth.emailRegister.bind(this.auth);
    this.getCurrentUser = this.auth.getCurrentUser.bind(this.auth);
    this.logout = this.auth.logout.bind(this.auth);
    this.updateProfile = this.auth.updateProfile.bind(this.auth);
  }

  // Dashboard API methods
  async getDashboardStats() {
    return this.request('/dashboard/stats');
  }

  async getDashboardUsage(days = 7) {
    return this.request(`/dashboard/usage?days=${days}`);
  }

  async getDashboardActivity(limit = 20) {
    return this.request(`/dashboard/activity?limit=${limit}`);
  }

  async getDashboardProfile() {
    return this.request('/dashboard/profile');
  }
}

export default new ApiService();
